import React, { useContext, useState } from "react";
import { AppContext } from "./index.js";
import { Story, Adjunto } from "./contexto/ClasesGrales";
import { SInput, SEtiqueta, SInputD, codiguera } from "./general";
import Boton from "./Boton.js";

export default function CRUDhistorias({ proyecto }) {
    let { firebase } = useContext(AppContext);

    const [s, setS] = useState(new Story(proyecto));
    const [adjunto, setAdjunto] = useState(new Adjunto());
    const [imageAsFile, setImageAsFile] = useState(null);
    const [change, setChange] = useState(false)

    async function actualizarHistoria() {
        if (imageAsFile) {
            const uploadTask = firebase.storage.ref(`historias/${s.proyecto}/${s.id}/${s.files[0].nombre}`).put(imageAsFile);

            uploadTask.on(
                "state_changed",
                (snapShot) => {
                    var progress = (snapShot.bytesTransferred / snapShot.totalBytes) * 100;
                    console.log("Upload de Historia de usuario is " + progress + "% done");
                },
                (err) => {
                    console.log("Error al cargar el documento de historia de usuario", err);
                },
                () => {
                    uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                        s.adjunto.url = downloadURL; // no se puede actualizar con setS
                        firebase.actualizarHistoria(s);
                    });
                }
            );
        } else {
            firebase.actualizarHistoria(s);
        }
        setChange(false)
        setS(new Story(proyecto))
    }

    return (
        <div style={ScrudHistorias}>

            <div style={Sdescripcion}>
                <div style={{ ...SEtiqueta, marginBottom: "5px" }}>{s.id} - Nombre:</div>
                <textarea
                    rows="1"
                    style={{ ...SInputD, height: "6vh" }}
                    value={s.nombre}
                    onChange={(e) => {
                        e.persist(); setChange(true);
                        setS((s) => ({ ...s, nombre: e.target.value }));
                    }}
                >
                </textarea>
                <div style={{ ...SEtiqueta, marginBottom: "5px" }}>Descripción:</div>
                <textarea
                    rows="4"
                    style={{ ...SInputD, height: "20vh" }}
                    value={s.descripcion}
                    onChange={(e) => {
                        e.persist(); setChange(true);
                        setS((s) => ({ ...s, descripcion: e.target.value }));
                    }}
                ></textarea>
            </div>

            <div style={SDataEntry}>

                <div style={SEtiqueta}>Estado:</div>
                <select
                    style={SInput}
                    value={s.estado}
                    onChange={(e) => {
                        e.persist(); setChange(true);
                        setS((s) => ({ ...s, estado: e.target.value }));
                    }}
                >
                    {Object.values(codiguera["estadoHistoria"]).map(e =>
                        <option value={e} key={e}>{e}</option>)}
                </select>
                <div style={SEtiqueta}>Prioridad:</div>
                <select
                    style={SInput}
                    value={s.prioridad}
                    onChange={(e) => {
                        e.persist(); setChange(true);
                        setS((s) => ({ ...s, prioridad: e.target.value }));
                    }}
                >
                    {Object.values(codiguera["prioridad"]).map(e =>
                        <option value={e} key={e}>{e}</option>)}
                </select>
                <div style={SEtiqueta}>Tipo:</div>
                <select
                    style={SInput}
                    value={s.tipo}
                    onChange={(e) => {
                        e.persist(); setChange(true);
                        setS((s) => ({ ...s, tipo: e.target.value }));
                    }}
                >
                    {Object.values(codiguera["tipoHistoria"]).map(e =>
                        <option value={e} key={e}>{e}</option>)}
                </select>
                <div style={SEtiqueta}>Horas:</div>
                <input
                    style={SInput}
                    value={s.horas}
                    type="number"
                    onChange={(e) => {
                        e.persist(); setChange(true);
                        setS((s) => ({ ...s, horas: e.target.value }));
                    }}
                >
                </input>
                <div style={SEtiqueta}>Puntos:</div>
                <input
                    style={SInput}
                    value={s.puntos}
                    type="number"
                    onChange={(e) => {
                        e.persist(); setChange(true);
                        setS((s) => ({ ...s, puntos: e.target.value }));
                    }}
                >
                </input>
            </div>

            <Boton accion={actualizarHistoria} change={change} />

        </div>
    );
}

const ScrudHistorias = {
    margin: "10px"
}

const Sdescripcion = {
    marginBottom: "5px"
};

const SDataEntry = {
    display: "grid",
    gridTemplateColumns: "24% 24% 24% 24%",
    rowGap: "5px",
    columnGap: "5px"
};


